import { render, staticRenderFns } from "./DependentInformation.vue?vue&type=template&id=47d9c787&"
import script from "./DependentInformation.vue?vue&type=script&lang=js&"
export * from "./DependentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports